module.exports = __webpack_public_path__ + "hoop_visita_02_02.png";